import { render } from "./CaribeCoolerView.vue?vue&type=template&id=c07a427e"
import script from "./CaribeCoolerView.vue?vue&type=script&lang=js"
export * from "./CaribeCoolerView.vue?vue&type=script&lang=js"

import "./CaribeCoolerView.vue?vue&type=style&index=0&id=c07a427e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__